import { addVariationsToProducts } from './loop-products'
import { addOverlay, addCloseBtn } from '../utils/modal'
import { initResponsiveModal } from '../utils/responsive-modal'

/**
 * Add dropdown attributes to filters
 * - data-dropdown-trigger: The id of the filter
 * - data-dropdown: The id of the filter dropdown
 */
function addAttributesToFilters() {
    // Scope to .archive-filters so we don't catch unrelated widgets (e.g. product categories sidebar)
    const filters = document.querySelectorAll('.archive-filters .woo-widget:not(.widget_layered_nav_filters)')
    filters.forEach((filter) => {
        const id = filter.id
        const filterButton = filter.querySelector('.widget-button')
        const filterDropdown = filter.querySelector('ul')
        if (!filterButton || !filterDropdown) return
        filterButton.setAttribute('data-dropdown-trigger', id)
        filterDropdown.setAttribute('data-dropdown', id)
    })
}

document.addEventListener('DOMContentLoaded', () => {
    addAttributesToFilters()
})

/**
 * Add modal attributes to filters on mobile.
 * Delar logik med kategori-sidebaren via initResponsiveModal.
 */
function handleModalAttributesForFilters() {
    initResponsiveModal('.archive-filters', 'filters')
}

document.addEventListener('DOMContentLoaded', () => {
    handleModalAttributesForFilters()
})

/**
 * Lazy URL updater (prevents spamming pushState)
 */
let lazyUrlTimer = null
function lazyUpdateUrl(url, delay = 300) {
    clearTimeout(lazyUrlTimer)
    lazyUrlTimer = setTimeout(() => {
        window.history.pushState({}, '', url)
    }, delay)
}

/**
 * Prefetch cache
 */
const archivePrefetchCache = new Map()

/**
 * Prefetch URL if not already cached
 */
async function prefetchArchive(url) {
    if (!url || archivePrefetchCache.has(url)) return

    try {
        const response = await fetch(url, {
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
        })
        const html = await response.text()
        archivePrefetchCache.set(url, html)
    } catch (err) {
        console.warn('Prefetch failed:', url)
    }
}

/**
 * SCROLL FLAG (only scroll on pagination)
 */
let shouldScrollToAnchor = false

/**
 * Apply DOM updates from parsed HTML
 */
function updateArchiveDomFromDoc(doc) {
    const productListing = document.querySelector('ul.products')
    const resultCount = document.querySelector('.woocommerce-result-count')
    const pagination = document.querySelector('.woocommerce-pagination')
    const filtersActive = document.querySelector('.widget_layered_nav_filters')
    const archiveFilters = document.querySelector('.archive-filters')
    const ordering = document.querySelector('.woocommerce-ordering')

    const newProducts = doc.querySelector('ul.products')
    const newResultCount = doc.querySelector('.woocommerce-result-count')
    const newPagination = doc.querySelector('.woocommerce-pagination')
    const newFiltersActive = doc.querySelector('.widget_layered_nav_filters')
    const newArchiveFilters = doc.querySelector('.archive-filters')
    const newOrdering = doc.querySelector('.woocommerce-ordering')

    if (newProducts && productListing) {
        productListing.innerHTML = newProducts.innerHTML
        productListing.classList.remove('animate-pulse')
        // Re-init WooCommerce variations på nya formulär (Woo kräver jQuery...)
        if (window.jQuery) {
            jQuery(function ($) {
                const $forms = $('.variations_form')
                if ($forms.length) {
                    $forms.each(function () {
                        $(this).wc_variation_form()
                    })
                }
            })
        }
        addVariationsToProducts()
    }
    if (newArchiveFilters && archiveFilters) {
        archiveFilters.innerHTML = newArchiveFilters.innerHTML
        addAttributesToFilters()
    }
    if (newOrdering && ordering) {
        ordering.innerHTML = newOrdering.innerHTML
    }
    if (newFiltersActive && filtersActive) {
        filtersActive.innerHTML = newFiltersActive.innerHTML
    } else if (!newFiltersActive && filtersActive) {
        filtersActive.innerHTML = ''
    }
    if (newResultCount && resultCount) {
        resultCount.innerHTML = newResultCount.innerHTML
    }
    if (newPagination && pagination) {
        pagination.innerHTML = newPagination.innerHTML
    } else if (!newPagination && pagination) {
        pagination.innerHTML = ''
    } else if (newPagination && !pagination) {
        const newPaginationEl = document.createElement('nav')
        newPaginationEl.className = 'woocommerce-pagination'
        newPaginationEl.innerHTML = newPagination.innerHTML
        productListing?.after(newPaginationEl)
    }

    // PREFETCH next pagination page
    const nextPageLink = newPagination?.querySelector('a.next') || newPagination?.querySelector('.page-numbers.next')

    if (nextPageLink) {
        prefetchArchive(nextPageLink.href)
    }

    // SCROLL TO ANCHOR IF PAGINATION TRIGGERED
    if (shouldScrollToAnchor) {
        const anchor = document.querySelector('#pagination-anchor')
        if (anchor) {
            anchor.scrollIntoView({ behavior: 'smooth' })
        }
        shouldScrollToAnchor = false
    }

    // On mobile only - when filters are opened in a modal.
    // The overlay and close button needs to be re-added to the modal when filters are applied and the modal is open.
    if (window.innerWidth < 1024 && archiveFilters) {
        addOverlay(archiveFilters)
        addCloseBtn(archiveFilters.querySelector('div:last-child'))
    }
}

/**
 * Update archive via fetch
 */
async function updateArchive(url) {
    const productListing = document.querySelector('ul.products')
    const wooWidgets = document.querySelectorAll('.woo-widget, .woocommerce-ordering')
    if (productListing) productListing.classList.add('animate-pulse')
    if (window.innerWidth < 1024 && wooWidgets) {
        wooWidgets.forEach((widget) => widget.classList.add('animate-pulse'))
    }

    const response = await fetch(url, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
    })

    const html = await response.text()
    archivePrefetchCache.set(url, html)

    const parser = new DOMParser()
    const doc = parser.parseFromString(html, 'text/html')

    updateArchiveDomFromDoc(doc)

    // Update active filters count
    updateActiveFiltersCount()
}

/**
 * Update archive using cached HTML
 */
function updateArchiveFromHTML(html) {
    const parser = new DOMParser()
    const doc = parser.parseFromString(html, 'text/html')
    updateArchiveDomFromDoc(doc)
    // Update active filters count
    updateActiveFiltersCount()
}

/**
 * CLICK HANDLING (filters + pagination)
 */
document.addEventListener('click', (e) => {
    const link = e.target.closest('a')
    if (!link) return

    const isFilter = link.closest('.woo-widget')
    const isPagination = link.closest('.woocommerce-pagination')

    // Only handle filters + pagination
    if (!isFilter && !isPagination) return

    // Underkategori-widgeten byter KATEGORI (inte bara filtrerar nuvarande vy) —
    // låt dess länkar navigera normalt istället för att ajax-swappa innehållet.
    if (link.closest('.widget_lw_category_subfilter')) return

    e.preventDefault()
    const url = link.href

    // Mark scroll needed only for pagination
    shouldScrollToAnchor = !!isPagination

    // Lazy URL update (clean browser history)
    lazyUpdateUrl(url)

    // Use prefetch cache if available
    if (archivePrefetchCache.has(url)) {
        updateArchiveFromHTML(archivePrefetchCache.get(url))
    } else {
        updateArchive(url)
    }
})

/**
 * UPDATE ACTIVE FILTERS COUNT
 */
function updateActiveFiltersCount() {
    const widget_layered_nav_filters = document.querySelector('.widget_layered_nav_filters')
    const activeFiltersCount = document.querySelector('.active-filters-count')

    if (!widget_layered_nav_filters && !activeFiltersCount) return

    if (!widget_layered_nav_filters) {
        activeFiltersCount.classList.remove('active')
        activeFiltersCount.textContent = '0'
        return
    }

    const activeFilters = widget_layered_nav_filters.querySelectorAll('li.chosen')
    if (activeFilters.length > 0) {
        activeFiltersCount.classList.add('active')
        activeFiltersCount.textContent = activeFilters.length
    }
}

document.addEventListener('DOMContentLoaded', () => {
    updateActiveFiltersCount()
})

/**
 * HOVER-PREFETCH pagination links
 */
document.addEventListener('mouseover', (e) => {
    const link = e.target.closest('.woocommerce-pagination a')
    if (link) prefetchArchive(link.href)
})

/**
 * SORTING
 */
document.addEventListener('change', (e) => {
    if (!e.target.matches('.woocommerce-ordering .orderby')) return

    const url = new URL(location.href)
    url.searchParams.set('orderby', e.target.value)

    e.preventDefault()
    shouldScrollToAnchor = false // no scroll on sorting

    lazyUpdateUrl(url.toString())

    if (archivePrefetchCache.has(url.toString())) {
        updateArchiveFromHTML(archivePrefetchCache.get(url.toString()))
    } else {
        updateArchive(url.toString())
    }
})

/**
 * BACK/FORWARD with popstate
 */
window.addEventListener('popstate', () => {
    const url = location.href

    shouldScrollToAnchor = false // never auto-scroll when navigating history

    if (archivePrefetchCache.has(url)) {
        updateArchiveFromHTML(archivePrefetchCache.get(url))
    } else {
        updateArchive(url)
    }
})
